import { Component, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
  	selector: 'app-toolcards-managing-risk',
  	templateUrl: './toolcards-managing-risk.component.html',
  	styleUrls: ['./toolcards-managing-risk.component.scss']
})
export class ToolcardsManagingRiskComponent implements OnInit {
	public env;

  	constructor() { }

  	ngOnInit() {
  		this.env=environment;
  	}

}
